import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "absolute top-0 left-0 h-full bg-gradient-to-b from-[#00000020] to-[#00000095] flex flex-col p-5 w-full rounded-lg z-10 opacity-0 group-hover:opacity-100 transition-opacity" }
const _hoisted_2 = { class: "p-4 text-white mt-auto" }
const _hoisted_3 = { class: "font-bold font-captions text-4xl" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Click to open PDF.", -1)
const _hoisted_5 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    tabindex: "0",
    class: "relative aspect-[3/2] rounded-lg overflow-hidden group cursor-pointer border-2 border-gray-200",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openPdfDocument(_ctx.design.src)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.design.title), 1),
        _hoisted_4
      ])
    ]),
    _createElementVNode("img", {
      src: _ctx.loadThumbnail(_ctx.design.thumbnail),
      alt: _ctx.design.title,
      class: "relative object-cover object-top cursor-pointer aspect-[3/2] rounded-lg"
    }, null, 8, _hoisted_5)
  ]))
}